import { useBucket } from '@mc/experiments-react'
import { CTA_ON_MOBILE_NAV_EXP_FLAG } from './constants'

export const useCTAonMobileNavExperiment = () => ({
  isPen5294Variant:
    useBucket<'control' | 'variant_1'>(CTA_ON_MOBILE_NAV_EXP_FLAG) ===
    'variant_1',
})
